import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faPhoneVolume} from "@fortawesome/free-solid-svg-icons"
import { Nav, OverlayTrigger, Popover } from 'react-bootstrap';
// import {whatsappUrlMessage} from '@/utils'
import { SocialMenu } from '@/constants/Menus';
import ContactoMenu from '@/Shared/Layouts/Menus/ContactoMenu';

const ItemSocial = ({withName, ...props}) => {
	const icon = props.lateralIcon||props.icon;
	const children = props.children||<Nav.Link as={props.href?undefined:"div"} href={props.href||undefined} title={props.name} 
		target={props.external?"_blank":undefined} {...props.props} role="button"
		className={'text-'+(props.light?'dark':"white")} style={{backgroundColor: props.color||"#dddddd"}}
	>
		{icon && <FontAwesomeIcon icon={icon} />} 
		<span className={withName?"ml-1":"sr-only"}>{props.name}</span>
	</Nav.Link>

	const cnt = <Nav.Item as="li">
		{props.overlay ? <OverlayTrigger {...props.overlay}>{children}</OverlayTrigger> : children}
	</Nav.Item>
	return cnt;
}

export default ({withNames, ...props}) => {
    // const goWhatsapp = whatsappUrlMessage("¡Hola!");
    props.className = "lateral-social"+(props.className?' '+props.className:'');
	const menus = SocialMenu.map((itm, idx)=>{
		return <ItemSocial {...itm} withName={withNames} key={itm.name}/>;
	})
	menus.unshift(<ItemSocial name="Datos de contacto" icon={faPhoneVolume} 
		withName={withNames} key={'contacto'} light overlay={{
			trigger:"click",
			key: "contactoLateralSocialPop",
			placement: "right",
			overlay: <Popover id={`contactoLateralSocialPop`}>
				<Popover.Title as="h3">{`Datos de contacto`}</Popover.Title>
				<Popover.Content>
					<ContactoMenu className="flex-column" />
				</Popover.Content>
			</Popover>
		}} />)
	return <Nav {...props}>
		{menus}
		{/* <Nav.Item as="li">
			<Nav.Link eventKey="link-1">Link</Nav.Link>
		</Nav.Item>
		<Nav.Item as="li">
			<Nav.Link eventKey="link-2">Link</Nav.Link>
		</Nav.Item> */}
	</Nav>
}